import { getAllSupportReasonTags } from "../create/supportTicketReasonCategories";

const supportTagSuggestions = [
  ...getAllSupportReasonTags(),
  "testy",
  "zle-zamowienie",
  "blik",
  "platnosc",
  "zwrot",
  "reklamacja",
  "dostawa",
  "brak-przesylki",
  "blad-systemu",
  "integracja",
  "faktura",
  "anulowanie",
  "vip",
  "pilne",
];

const normalizeTag = (value: string) => value.trim().toLowerCase();

export const getSupportTagOptions = (searchText: string, selectedTags: string[] = []) => {
  const normalizedSearch = normalizeTag(searchText);
  const selected = selectedTags.map(normalizeTag);
  const allTags = [...supportTagSuggestions, ...selected].filter(
    (tag, index, list) => list.indexOf(tag) === index,
  );

  return allTags
    .filter((tag) => (normalizedSearch ? tag.includes(normalizedSearch) : true))
    .map((tag) => ({ label: `#${tag}`, value: tag }));
};
